import { context } from '@wikia/ad-engine';

export function getTripleliftContext(): object {
	const floorAdhesionConfig = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.adhesion_limited ?? [
						[300, 50],
						[320, 50],
					],
					/* The same inventory code is used for both configs
					 * Source - https://fandom.atlassian.net/browse/ADEN-14222?focusedCommentId=787568 */
					inventoryCodes: ['Fandom_Fixed_320x50'],
				},
			}
		: {};

	return {
		enabled: false,
		slots: {
			mobile_top_leaderboard: {
				sizes: [[320, 50]],
				inventoryCodes: ['Fandom_MW_LB_320x50_hdx_prebid'],
			},
			mobile_in_content: {
				sizes: [[300, 250]],
				inventoryCodes: ['Fandom_Mobile_InContent_prebid'],
			},
			gallery_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.gallery_leaderboard ?? [
					[320, 100],
					[320, 50],
				],
				inventoryCodes: ['fandom_mw_galleries'],
			},
			bottom_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.bottom_leaderboard ?? [
					[300, 250],
					[320, 50],
				],
				inventoryCodes: ['Fandom_MW_PF_300x250_hdx_prebid', 'Fandom_MW_PF_320x50_hdx_prebid'],
			},
			...floorAdhesionConfig,
		},
	};
}
